import React, { FunctionComponent } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { APP } from 'Configs/App'
import { getHidden } from 'Redux/selectors/sidebar'
import { getIsAuth, getUser, getUserRole } from 'Redux/selectors/auth'
import Layout from 'Containers/Layout'
import MainWrapper from 'Containers/App/MainWrapper'
import { Roles } from 'Constants/enums'
import PublicRoute from './PublicRoute'
import PublicComponents from './PublicComponents'
import ArtistProtected from './ArtistProtected'
import ArtistComponents from './ArtistComponents'
import CuratorProtected from './CuratorProtected'
import CuratorComponents from './CuratorComponents'
import { InfluencerProtected } from './InfluencerProtected'
import { InfluencerComponents } from './InfluencerComponents'
import { User, Influencer } from '../Types'

type RouterProps = {
  isAuth: boolean
  role: Roles
  user: User
  influencer?: Influencer
  hidden: boolean
}

const protectedPages = {
  [Roles.artist]: {
    UserProtected: ArtistProtected,
    UserComponents: ArtistComponents,
  },
  [Roles.curator]: {
    UserProtected: CuratorProtected,
    UserComponents: CuratorComponents,
  },
  [Roles.influencer]: {
    UserProtected: InfluencerProtected,
    UserComponents: InfluencerComponents,
  },
}

const Router: FunctionComponent<RouterProps> = ({
  isAuth = false,
  role,
  user,
  hidden,
}) => {
  if (APP.admin_email.includes(user?.email)) {
    localStorage.setItem('admin', 'true')
  }
  const WrapClass = classNames({
    container__wrap: isAuth,
    'container__full-screen': hidden,
  })

  // @ts-ignore
  const { UserProtected, UserComponents } = protectedPages[role] ?? {}

  return (
    <MainWrapper>
      <main>
        <PublicRoute component={PublicComponents} isAuth={isAuth} />

        {isAuth && <Layout />}

        <div className={WrapClass}>
          {isAuth && UserProtected && (
            <UserProtected component={UserComponents} user={user} />
          )}
        </div>
      </main>
    </MainWrapper>
  )
}

const selector = createStructuredSelector({
  isAuth: getIsAuth,
  role: getUserRole,
  // @ts-ignore
  user: getUser,
  hidden: getHidden,
})

export default connect(selector)(Router)
